import { IconType, SvgIcon } from './SvgIcon';

export const ExpandIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path
      d="M6.66667 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V6.66667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M17.5007 6.66667V4.16667C17.5007 3.72464 17.3251 3.30072 17.0125 2.98816C16.6999 2.67559 16.276 2.5 15.834 2.5H13.334"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M2.5 13.3335V15.8335C2.5 16.2755 2.67559 16.6994 2.98816 17.012C3.30072 17.3246 3.72464 17.5002 4.16667 17.5002H6.66667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M13.334 17.5002H15.834C16.276 17.5002 16.6999 17.3246 17.0125 17.012C17.3251 16.6994 17.5007 16.2755 17.5007 15.8335V13.3335"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </SvgIcon>
);

ExpandIcon.displayName = 'ExpandIcon';
